(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9545],{

/***/ 16512:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test/chat-popup",
      function () {
        return __webpack_require__(96561);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ModalDemo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86010);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(30120);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13264);
/* harmony import */ var _mui_base_Modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(53712);
/* harmony import */ var _mui_icons_material_MarkChatReadOutlined__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47695);
/* harmony import */ var _src_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5786);
/* harmony import */ var _testchat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28097);
/* harmony import */ var _src_utils_LightTooltip__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14569);
/* eslint-disable no-unused-vars */ /* eslint-disable react/require-default-props */ /* eslint-disable no-use-before-define */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  z-index: 1300;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: -1;\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  -webkit-tap-highlight-color: transparent;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var IconText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
    return {
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.575rem",
        fontWeight: 500,
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary
    };
});
var StyledIcon = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
    return {
        paddingTop: "2px",
        paddingBottom: "2px",
        height: "18px",
        width: "18px",
        color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_primary */ .T.palette_primary,
        "&:hover": {
            color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
        }
    };
});
function ModalDemo() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(false), 2), open = ref[0], setOpen = ref[1];
    var handleOpen = function() {
        return setOpen(true);
    };
    var handleClose = function() {
        return setOpen(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TriggerButton, {
                type: "button",
                onClick: handleOpen,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIcon, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_icons_material_MarkChatReadOutlined__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                fontSize: "small",
                                sx: {
                                    color: _src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.palette_secondary */ .T.palette_secondary
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconText, {
                            variant: "caption",
                            children: "ChatBot"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledModal, {
                "aria-labelledby": "unstyled-modal-title",
                "aria-describedby": "unstyled-modal-description",
                open: open,
                onClose: handleClose,
                slots: {
                    backdrop: StyledBackdrop
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    sx: {},
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_testchat__WEBPACK_IMPORTED_MODULE_4__["default"], {})
                })
            })
        ]
    });
}
var Backdrop = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function(props, ref) {
    var open = props.open, className = props.className, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(props, [
        "open",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_15__["default"])({
            "MuiBackdrop-open": open
        }, className),
        ref: ref
    }, other));
});
Backdrop.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string.isRequired),
    open: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool)
};
var blue = {
    200: "#99CCF3",
    400: "#3399FF",
    500: "#007FFF"
};
var grey = {
    50: "#f6f8fa",
    100: "#eaeef2",
    200: "#d0d7de",
    300: "#afb8c1",
    400: "#8c959f",
    500: "#6e7781",
    600: "#57606a",
    700: "#424a53",
    800: "#32383f",
    900: "#24292f"
};
var StyledModal = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_mui_base_Modal__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_templateObject());
var StyledBackdrop = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Backdrop)(_templateObject1());
var style = function(theme) {
    return {
        width: 700,
        borderRadius: "12px",
        padding: "16px 32px 24px 32px",
        backgroundColor: theme.palette.mode === "dark" ? "#0A1929" : "white",
        boxShadow: "0px 2px 24px ".concat(theme.palette.mode === "dark" ? "#000" : "#383838")
    };
};
var TriggerButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("button")(function(param) {
    var theme = param.theme;
    return "\n  font-family: IBM Plex Sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  box-sizing: border-box;\n  min-height: calc(1.5em + 22px);\n  border-radius: 12px;\n  padding: 6px 12px;\n  line-height: 1.5;\n  background: transparent;\n  border: 1px solid transparent;\n  color: ".concat(_src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_100 */ .T.token_grey_100, ";\n  &:hover {\n    background: ").concat(_src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_10 */ .T.token_grey_10, ";\n    border-color: ").concat(_src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_grey_300 */ .T.token_grey_300, ";\n  }\n  &:focus-visible {\n    border-color: ").concat(_src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_500 */ .T.token_blue_500, ";\n    outline: 3px solid ").concat(_src_tokens__WEBPACK_IMPORTED_MODULE_3__/* .tokens.token_blue_200 */ .T.token_blue_200, ";\n  }\n  ");
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1265,3517,4540,3835,1816,5426,517,2390,247,7575,8653,5543,7155,5696,9250,7315,9115,8097,9774,2888,179], function() { return __webpack_exec__(16512); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);